import { useEffect, useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

import { getCurrentUser } from '@/helpers/session_helper';

import { useGlobalDispatch } from './useGlobalEvent';

import { useSwitchProgramAuthenticationMutation } from '@/api/Endpoints/Core/Authentication/Login';
import { useLookUpGloboProgramsMutation } from '@/api/Endpoints/Globo/StaticData/Programs';

const ProgramDropdown = () => {
    const currentUser = getCurrentUser();
    const dispatch = useGlobalDispatch();

    const [programs, setPrograms] = useState([]);
    const [selected, setSelected] = useState({
        programId: currentUser?.programId,
        programName: currentUser?.programName,
    });

    const [isOpen, setIsOpen] = useState(false);

    const [lookUpProgram] = useLookUpGloboProgramsMutation();
    const [switchProgram] = useSwitchProgramAuthenticationMutation();

    useEffect(() => {
        const fetchPrograms = async () => {
            try {
                const result = await lookUpProgram("").unwrap();
                setPrograms(result);
            } catch (err) {
                console.warn("Failed to load programs:", err);
            }
        };
        fetchPrograms();
    }, []);

    const handleSelect = async (program) => {
        const payload = {
            principalId: program?.principalId,
            programId: program.value,
            programName: program.label,
        };

        try {
            const response = await switchProgram(payload).unwrap();

            const updatedUser = response?.returnData;
            sessionStorage.setItem("currentUser", JSON.stringify(updatedUser));

            setSelected({ programId: program.programId, programName: program.programName });

            dispatch("globo-program-changed", { programId: program.value, principalId: program?.principalId, });
        } catch (err) {
            console.warn("Switch program failed:", err);
        }
    };

    return (
        <Dropdown isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} className="ms-1 topbar-head-dropdown header-item">
            <DropdownToggle
                className="btn text-success btn-ghost-secondary border-0 no-hover program-toggle"
                tag="button"
                style={{
                    fontWeight: 600,
                    borderRadius: "4px",
                    whiteSpace: "nowrap",
                }}
            >
                {currentUser?.programName ?? "—"}
            </DropdownToggle>
            <DropdownMenu className="py-2">
                {programs.map(p => (
                    <DropdownItem
                        key={p.value}
                        onClick={() => handleSelect(p)}
                        className={currentUser?.programId === p.value ? "active" : ""}
                    >
                        {p.label}
                    </DropdownItem>
                ))}
            </DropdownMenu>
        </Dropdown>
    );
};

export default ProgramDropdown;